import type { APIResponse } from "../api";

/** Core/Laravel proxy: already-verified email — no OTP sent; user should log in or resume elsewhere. */
export function isAlreadyVerifiedEmailResponse(
  data: APIResponse | undefined
): boolean {
  const d = data?.data as
    | {
        emailVerified?: boolean;
        nextStep?: string;
      }
    | undefined;
  if (!d?.emailVerified) return false;
  return d.nextStep === "login" || d.nextStep === "profile_creation";
}
